import { createAction } from '@reduxjs/toolkit';
import { Notification } from 'src/services';

export const useNotificationsWSActions = {
  create: createAction<{ notification: Notification }>('UseNotificationsWSActions/Create'),
  view: createAction<{ notificationIds: string[] }>('UseNotificationsWSActions/Update'),
  delete: createAction<{ notificationIds: string[] }>('UseNotificationsWSActions/Delete'),
  unreadCount: createAction<{ unreadCount: number }>('UseNotificationsWSActions/UnreadCount'),
};
